angular.module('unica_invitation_group.invitation_group_controllers')

.controller('InvitationGroupListController', function(
	$rootScope, $scope, $state, $stateParams,
	$confirm, $uibModal,
	InvitationGroupListService, InvitationGroupDeleteService
) {
	$scope.event_id = $stateParams.event_id;

	$rootScope.getEvent( $stateParams.event_id );

	$scope.invitationGroupList = [];
	$scope.loadInvitationGroups = function()
	{
		$scope.showLoader();
		InvitationGroupListService
			.list($scope.event_id)
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.invitationGroupList = data;
				}
			});
	};

	$scope.loadInvitationGroups();


	$scope.deleteInvitationGroup = function(notificationId)
	{
		$confirm({
			title: 'Sei sicuro di voler eliminare il gruppo?',
			text: 'Confermi la cancellazione del gruppo?'
		}).then(function() {

			$scope.showLoader();

			InvitationGroupDeleteService
				.delete( notificationId )
				.then(function(data) {
					$scope.hideLoader();

					if ( data ) {
						angular.forEach($scope.invitationGroupList, function(notification, key) {
							if ( notification.id === notificationId ) {
								$scope.invitationGroupList.splice(key, 1);
							}
						});
						$scope.showSuccessMsg('Gruppo eliminato con successo!', '');
					}

				});

		}, function() {
			// Cancel
		});
	};


	$scope.openInvitationGroupInvitationsModal = function (eventId, notificationId)
	{
		var modalInstance = $uibModal.open({
			ariaLabelledBy: 'modal-title',
			ariaDescribedBy: 'modal-body',
			controller: 'ModalInvitationGroupInvitationsInstanceController',
			controllerAs: '$ctrl',
			templateUrl: './templates/modals/notification-invitations.html',
			size: 'lg',
			windowClass: 'modal-invitation-list',
			resolve: {
				notificationId: function () {
					return notificationId;
				},
				eventId: function() {
					return eventId;
				}
			}
		});
	};


})

.controller('ModalInvitationGroupInvitationsInstanceController',
	function ($scope, $uibModalInstance, eventId, notificationId, InvitationGroupAssignService) {

		$scope.notificationEmails = [];

		$scope.loadInvitationGroupEmails = function() {
			$scope.showLoader();

			InvitationGroupAssignService
				.list( eventId, notificationId  )
				.then(function(data) {
					$scope.hideLoader();

					if ( data ) {
						$scope.notificationInvitations = data;
					}
				});
		};
		$scope.loadInvitationGroupEmails();


		$scope.closeModal = function() {
			$uibModalInstance.dismiss('cancel');
		};

	});